import styled, { css } from 'styled-components'
import { customScrollbar } from 'styles/scrollbar'

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  border-radius: 12px;
  background: var(--t-surface-2);

  ${({ $scrollable }) =>
    $scrollable &&
    css`
      max-height: 350px;
      overflow-y: auto;

      ${customScrollbar}

      &::-webkit-scrollbar-track {
        margin-block: 5px;
      }
    `}
`
